<docs>
  # UiKit - Button - link
  > *generic way to create any link cta*
</docs>
  
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import UiButtonSimple from './index.vue';

const UiButtonThemedTheme = defineComponent({
  name: "UiButtonThemedTheme",
  components:{UiButtonSimple},
  extends:UiButtonSimple,
  props:{
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'theme'
    },
    subtitle: {
      type: String,
      default: null
    }
  },
});
export default UiButtonThemedTheme
</script>
  
<template>
  <ui-button-simple class="UiButtonThemed"
                    :data-theme="theme"
                    :data-variant="variant"
                    :data-dark="dark"
                    :data-selected="selected"
                    :data-highlight="true"
                    v-bind="$props"
  >
    <span v-if="$props.subtitle"
          class="subtitle"
          :data-label="$props.subtitle"
    >{{ $props.subtitle }}</span>
    <slot>
      <span v-if="$props.label"
            class="label"
            :data-label="$props.label"
      >{{ $props.label }}</span>
    </slot>
  </ui-button-simple>
</template>
  
<style lang="stylus" scoped>
  [data-theme="theme"]
    display inline-block
    position relative
    f(center, $direction:column)
    rp(width, 300px)
    rp(padding-top, 42px)
    rp(padding-bottom, 42px)
    rp(border-radius, 5px)
    &[data-dark="true"]
      addVariantHover(true)
    &[data-dark="false"]
      addVariantHover(false)

    span
      display block

    .label
      f-style(h4)
      text-transform uppercase
      user-select none

    .subtitle
      f-style(button)
      text-transform uppercase
      margin-bottom 15px
      user-select none
  </style>
  